import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../GetProxy";
import { handleResponseCode } from "../../utilities/helpers";

const cookies = new Cookies();
const proxy = GetProxy();

export const getAllDeptDivsionAndApp = createAsyncThunk(
    "post/getAllDeptDivsionAndAppapi",
    async () => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const response = await fetch(
                `${proxy}/report/api/v1/Filter/mainFilterApi`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "DTOP-API-TOKEN": apiToken,
                        USERNAME: username,
                    },
                }
            );
            handleResponseCode(response);
            const data = await response.json();

            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);


const initialState = {
    DepartmentDivisionloading: false,
    DepartmentDivisionOption: [],
    CSPForAwsDataLoading: false,
    CSPForAzureDataLoading: false,
    CSPDataLoading: false,
    CSPForAwsData: [],
    CSPForAzureData: [],
    CSPData: [],
    ApplicationOption: [],
    AccountIDOption: [],
    AccountData: [],
    SubscriptionData: [],
    selectedMainFilterData: {
        Department: [],
        Division: [],
        Application: [],
        Platform: [],
        pluginFamily: [],
        selectedAccountIDs: [],
    },
    selectedFiltersData: {
        selectedDepartments: [],
        selectedDivisions: [],
        selectedCSV: [],
        selectedApplications: [],
        selectedAccountIDs: [],
        selectedSubscriptionName: [],
        selectedPluginFamilies: [],
    },
    activeFilterContext: "",
    ontabChange: false,
    error: false,
};

export const ComplianceMainFilterSlice = createSlice({
    name: "ComplianceMainFilterSlice",
    initialState,

    reducers: {
        resetAllFilter: (state) => {
            state.selectedFiltersData = {
                ...initialState.selectedFiltersData,
            };
        },
        resetFilters: (state, action) => {
            const keysToReset = action.payload.keysToReset;
            keysToReset.forEach((key) => {
                state.selectedFiltersData[key] = [];
            });
        },
        setSelectedMainFilterData: (state, action) => {
            state.selectedMainFilterData = action.payload;
        },
        setActiveFilterContext: (state, action) => {
            state.activeFilterContext = action.payload;
        },
        setError: (state, action) => {
            state.error = false;
        },
    },

    extraReducers: (builder) => {
        builder

            .addCase(getAllDeptDivsionAndApp.pending, (state, action) => {
                state.DepartmentDivisionloading = true;
                state.error = false;
                state.selectedMainFilterData = initialState?.selectedMainFilterData;
            })
            .addCase(getAllDeptDivsionAndApp.fulfilled, (state, action) => {
                state.DepartmentDivisionOption = action.payload;
                state.DepartmentDivisionloading = false;
                state.error = false;
            })
            .addCase(getAllDeptDivsionAndApp.rejected, (state, action) => {
                state.DepartmentDivisionloading = false;
                state.error = true;
            });

    },
});

export const { resetAllFilter } = ComplianceMainFilterSlice.actions;
export const { resetFilters } = ComplianceMainFilterSlice.actions;
export const {
    setSelectedMainFilterData,
    setActiveFilterContext,
} = ComplianceMainFilterSlice.actions;
export default ComplianceMainFilterSlice.reducer;
